<template>
  <div class="pass-container keep-sticky" v-if="!finishGame">
    <span>
      <span v-if="!freeDirect" class="free-direct-container">
        <span class="action-pill pass-pill free-direct-pill">NO FREE DIRECT</span>
      </span>
      <span v-for="(p, i) in getPassingSequence" :key="i">
        <span v-if="i != 0"> {{ " > " }}</span>
        <span :class="{
          active: getCurrentCount === i,
          player: true,
          'empty-seat': p.emptySeat,
        }">
          {{ p.name }}
        </span>
      </span>
    </span>
    <span class="actions-container" v-if="showActionBar">
      <span v-for="(c, i) in currentActionSequence" :key="i" :class="[actionMap[c].class, 'action-pill']">{{
        actionMap[c].label
      }}</span>
    </span>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";

export default {
  name: "PassingSequence",
  computed: {
    ...mapGetters(["getCurrentCount", "getPassingSequence"]),
    ...mapState(["finishGame", "questionDisplayMode", "gameType", "currentActionSequence", "freeDirect"]),

    showActionBar() {
      return (
        ((['Question', 'ShowAnswer', 'Answer'].includes(this.questionDisplayMode) && this.currentActionSequence?.length > 0))
      )
    }
  },
  data() {
    return {
      actionString: "CPWP",
      actionMap: {
        "C": {
          class: "correct-pill",
          label: "Correct"
        },
        "P": {
          class: "pass-pill",
          label: "Pass"
        },
        "W": {
          class: "wrong-pill",
          label: "Wrong"
        },
        "K": {
          class: "kill-pill",
          label: "Kill"
        },
        "R": {
          class: "correct-pill",
          label: "Correct 20"
        },
        "T": {
          class: "correct-pill",
          label: "Correct 10"
        },
        "Y": {
          class: "correct-pill",
          label: "Correct 5"
        },
        "F": {
          class: "wrong-pill",
          label: "Wrong 20"
        },
        "G": {
          class: "wrong-pill",
          label: "Wrong 10"
        },
        "H": {
          class: "wrong-pill",
          label: "Wrong 5"
        }
      }
    }
  }
};
</script>

<style scoped>
.pass-container {
  padding: 3px;
  line-height: min(40px, 6vmin);
  background-color: #fdfcf6;
  display: flex;
  justify-content: center;
  align-items: center;
}

.player {
  padding: 5px 10px;
  margin: 0 10px;
  font-size: min(20px, 2vmin);
  color: black;
}

.active {
  border: 1px solid black;
  /* text-decoration: underline; */
  background-color: #bdd4e7;
  border-radius: 10px;
  font-weight: bold;
}

.keep-sticky {
  position: sticky;
  top: 70px;
  z-index: 100;
}

.empty-seat {
  opacity: 0.2;
}

.actions-container {
  position: absolute;
  right: 0;
}

.free-direct-container {
  position: absolute;
  left: 5px;
}

@media (max-width: 800px) {
  .pass-container {
    flex-direction: column;
  }

  .actions-container,
  .free-direct-container {
    position: relative
  }
}

.action-pill {
  padding: 6px;
  border-radius: 5px;
  color: white;
  margin-right: 10px;
  opacity: 80%;
  font-weight: bold;
  font-size: min(20px, 2vmin);
}

.correct-pill {
  background-color: #349d34;
}

.wrong-pill {
  background-color: #bb5151;
}

.pass-pill,
.kill-pill {
  background-color: darkgray;
}

.free-direct-pill {
  color: black;
}
</style>
